import { Injectable, inject } from '@angular/core';
import { BaseConfig, MSSLIB_CONFIG, MssLibConfig } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly mssLibConfig = inject<MssLibConfig>(MSSLIB_CONFIG);

  model!: BaseConfig;

  get config(): any {
    return this.model;
  }

  get isLocal() {
    return window.location.hostname.indexOf('localhost') > -1;
  }

  get applicationName(): string {
    if (this.model && this.model.clientDomains) {
      const clientDomain = this.model.clientDomains.find((x) => x.domain === window.location.host);
      if (clientDomain) {
        return clientDomain.client;
      }
    }

    return this.mssLibConfig.applicationName;
  }

  async load(): Promise<any> {
    const configResponse = await fetch('assets/config.json');
    this.model = await configResponse.json();
    return this.model;
  }
}
